import { TPopupHorizontal } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'

import { ROUND_TABLE_TRANSLATION_KEYS } from '../../configs/translations'
import { RoundTableLabel } from '../roundTableLabel/RoundTableLabel'
import { RoundTableText } from '../roundTableText/RoundTableText'

import styles from './RoundTableSectionMark.module.scss'

interface IProps {
  exportDescription?: keyof typeof ROUND_TABLE_TRANSLATION_KEYS
}

export const RoundTableSectionMark = ({ exportDescription }: IProps) => {
  return (
    <RoundTableLabel>
      {exportDescription && (
        <Tooltip
          horizontalDirection={TPopupHorizontal.Left}
          textAlign="left"
          tipContent={() => (
            <div className={styles.tip}>
              <RoundTableText name={exportDescription} />
            </div>
          )}
        >
          <span className={styles.infoIcon} tabIndex={0}>
            <i className="kbase kbase-info" aria-hidden />
          </span>
        </Tooltip>
      )}
    </RoundTableLabel>
  )
}
